export default __webpack_public_path__ + "static/media/THE_SUN.a4ad1b6c.png";